export const removeCountryCode = phoneNumber => {
  if (phoneNumber && phoneNumber.startsWith('+')) {
    return phoneNumber.replaceAll(/^\+\d{2}/g, '');
  }

  return phoneNumber;
};
export const convertPersianToEnglish = str => {
  return str.replace(/[\u06F0-\u06F9]/g, char =>
    String.fromCharCode(char.charCodeAt(0) - 0x6c0)
  );
};
